import CustomLoadingComponent from './CustomLoadingComponent'

export default CustomLoadingComponent
